import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import dateFormat from "dateformat";
const SingleItem = ({ data, index, paginateData }) => {

    const [userData, setuserData] = useState([]);
    useEffect(() => {
        if(data?.user_id){
            fetch(`https://api.wlfmobile.com/api/admin/user/view/single/${data?.user_id}`, {
                method: 'GET',
            })
                .then((res) => res.json())
                .then((data) => {
                    setuserData(data.data)
                })
        }
    }, [])

    return (
        <>
            <tr>
                <td>{ (parseFloat(index + 1) + (parseFloat(paginateData?.page) * parseFloat(paginateData?.limit))) - 10 }</td>
                <td>
                    <span className="d-block">{userData?.fname} {userData?.lname}</span>
                    {/* <span>
                        <Link to="#" className="text--small">id</Link>
                    </span> */}
                </td>
                <td>
                    <span>{data?.Crypto}</span> <br />
                    {/* <span className="text--small">{data.Crypto}</span> */}
                </td>
                <td>{data.Amount} $</td>
               
                <td>
                    {data?.HighLow === "High"
                        ?
                        <span class="badge badge--success text-success">High</span>
                        :
                        <span className="badge badge--danger text-danger">Low</span>
                    }

                </td>
                <td>
                    {data?.Result === "Win"
                        ?
                        <span class="badge badge--success text-success">Win</span>
                        :
                        ''
                    }
                    {data?.Result === "Draw"
                        ?
                        <span className="badge badge--dark text-dark">Draw</span>
                        :
                        ''
                    }
                    {data?.Result === "Loss"
                        ?
                        <span className="badge badge--danger text-danger">Loss</span>
                        :
                        ''
                    }

                </td>
                <td>
                    {data?.Result === null
                        ?
                        <span className="badge badge--danger text-danger">Running</span>                   
                        :
                        <span className="badge badge--success text-success">Completed</span>
                    }
                   
                </td>
                <td>  {data.OutTime}</td>
                {/* <td> {data?.InTime && dateFormat(data?.createdAt, "dd-m-yyyy h:MM:ss TT")}</td> */}
            </tr>
        </>
    );
};

export default SingleItem;